var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppStore = function SvgAppStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19.213 12.763c-.028-3.032 2.546-4.507 2.664-4.576-1.458-2.072-3.717-2.355-4.511-2.378-1.898-.195-3.74 1.107-4.706 1.107-.986 0-2.475-1.088-4.08-1.056-2.064.03-3.996 1.196-5.055 3.006-2.187 3.69-.556 9.114 1.539 12.097 1.047 1.461 2.272 3.093 3.874 3.035 1.568-.063 2.154-.974 4.046-.974 1.875 0 2.425.974 4.06.938 1.682-.027 2.741-1.468 3.753-2.942 1.21-1.675 1.697-3.324 1.716-3.409-.04-.013-3.268-1.214-3.3-4.848m-3.087-8.916c.843-1.029 1.42-2.427 1.26-3.847-1.22.053-2.747.823-3.626 1.829-.778.886-1.473 2.338-1.293 3.704 1.371.1 2.779-.674 3.659-1.686"
  })));
};
export default SvgAppStore;